export class AccountCompetitionEntryView {

  competitionEntryId: string = '';
   competitionTitle: string = '';
   riderPersonId: string = '';
   riderName: string = '';

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }

}
